<section
	*ngIf="showRedirectNotice"
	style="min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 24px; background: #f4f7fb;"
>
	<div style="max-width: 560px; width: 100%; background: #ffffff; border: 1px solid #d8e1ee; border-radius: 10px; padding: 20px; box-shadow: 0 8px 20px rgba(20, 41, 61, 0.08); text-align: center;">
		<h2 style="margin: 0 0 10px 0; color: #16324f; font-size: 20px;">Sesión expirada</h2>
		<p style="margin: 0; color: #3f546b; font-size: 15px; line-height: 1.5;">{{ redirectNoticeMessage }}</p>
	</div>
</section>
